import moment from 'moment'
import {
  TRIGGERED_EXECUTIONS_MOCK,
  TRIGGERED_EXECUTION_DETAIL_MOCK,
  TRIGGERED_EXECUTION_DETAIL_MOCK_101,
  TRIGGERED_EXECUTION_DETAIL_MOCK_102
} from '../constants/triggeredExecutionMock'
import {
  ExecutionDetailResponse,
  TriggeredExecutionListResponse
} from '../types/TriggeredExecution'
import { ScriptFeedbackStep } from '../../mScripts/tessaScript/types/ScriptExecution'

const detailMocks: Record<number, ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] }> = {
  100: TRIGGERED_EXECUTION_DETAIL_MOCK,
  101: TRIGGERED_EXECUTION_DETAIL_MOCK_101,
  102: TRIGGERED_EXECUTION_DETAIL_MOCK_102
}

// TODO: Replace mock implementations with real axios calls when BE is ready:
// GET /v6/scripts/user/robots/:robotId/executions/triggered?from=...&to=...&limit=...
export const fetchTriggeredExecutions = (
  _robotId: number,
  from: string,
  to: string,
  _limit = 100
): Promise<{ data: TriggeredExecutionListResponse }> => {
  const filtered = TRIGGERED_EXECUTIONS_MOCK.triggeredExecutions.filter(t =>
    moment(t.executedAt).isSameOrAfter(moment(from).startOf('day')) &&
    moment(t.executedAt).isSameOrBefore(moment(to).endOf('day'))
  )
  return Promise.resolve({ data: { triggeredExecutions: filtered } })
}

// TODO: Replace mock implementation with real axios call when BE is ready:
// GET /v6/scripts/user/robots/:robotId/executions/:executionId
// Note: When integrating with real BE, also fetch script by scriptReferenceId
// and use getFeedbackSteps selector to derive scriptFeedbackSteps from execution steps.
export const fetchExecutionDetail = (
  _robotId: number,
  executionId: number
): Promise<{ data: ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] } }> =>
  Promise.resolve({ data: detailMocks[executionId] ?? TRIGGERED_EXECUTION_DETAIL_MOCK })
